<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card color="success" icon="mdi-clipboard-text" inline title="Generar cuentas por pagar1"
      class="px-5 py-3 mb-5">
      <v-row>
        <v-col cols="12" md="6">
          <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones" item-text="name"
            item-value="id" persistent-hint return-object single-line v-on:change="listarEdificios()"></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-select v-model="edificio" outlined :items="edificios" label="Edificios" item-text="name" item-value="id"
            persistent-hint return-object single-line v-on:change="listar()"></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" class="mt-10">
          <v-data-table :headers="headers" :items="AccountsPayables" sort-by="calories" class="elevation-1"
            :search="search" :loading="loadingTable" loading-text="Cargando... Por favor esperar">
            <template v-slot:item.due_date="{ item }">
              {{ formatDate(item.due_date) }}
            </template>
            <template v-slot:item.amount="{ item }">
              {{ formatCurrency(item.amount) }}
            </template>
            <template v-slot:item.total_paid_payable="{ item }">
              {{ formatCurrency(item.total_paid_payable) }}
            </template>

            <template v-slot:item.balance_due_payable="{ item }">
              <v-chip :color="getColor(item.balance_due_payable)">
                {{ formatCurrency(item.balance_due_payable) }}
              </v-chip>

            </template>
            <template v-slot:top>
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio-group v-model="row" row mandatory @change="changeRow">
                    <v-radio label="Pendiente" value="Pendiente"></v-radio>
                    <v-radio label="Pagado" value="Pagado"></v-radio>
                    <v-radio label="Todos" value="Todos"></v-radio>
                  </v-radio-group>
                </v-col>

              </v-row>
              <v-toolbar flat>
                <v-toolbar-title>Propiedades</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>

                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                      @click="editedIndex = -1, listaProveedores(edificio.id)">
                      Nuevo <caption></caption>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="close">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ formTitle }} </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                      <v-form ref="form" v-model="validForm">
                        <v-container>
                          <v-divider> </v-divider>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <!--
                              <v-select v-model="proveedor" outlined :items="proveedores" label="Proveedor"
                                item-text="name" item-value="id" persistent-hint return-object single-line></v-select>
                                -->
                              <v-autocomplete v-model="proveedor" outlined :items="proveedores" dense filled
                                label="Proveedor" item-text="name" item-value="id" persistent-hint
                                return-object></v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row>

                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="invoice_number" label="No Documento" required
                                :rules="requiredRule"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="amount" label="Monto" required
                                :rules="requiredRule"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="concept" label="Concepto" required
                                :rules="requiredRule"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">

                              <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field v-model="due_date" label="Fecha de pago" prepend-icon="mdi-calendar"
                                    readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="due_date" @input="menu1 = false"></v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-row>
                              <v-col cols="12" sm="12" md="12">
                                <v-text-field v-model="notes" label="Notas"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="close"> Cerrar </v-btn>
                      <v-btn color="primary" @click="guardar()"> Guardar </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Esta seguro de eliminar datos?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="openDetalle(item)">
                    <v-icon dense color="warning">mdi-magnify-plus</v-icon>
                  </v-btn>
                </template>
                <span>Ver detalles</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="editar(item)">
                    <v-icon dense color="secondary">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="deleteItem(item)">
                    <v-icon dense color="primary">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Recargar </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialogDetails" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogDetails = false, listar()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Detalles de cuentas x pagar</v-toolbar-title>
          <v-spacer></v-spacer>

        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" lg="6">
              <base-material-stats-card color="info" icon="mdi-bank" title="Proveedor"
                :value="descriptionPopUp.toString()" />
            </v-col>
            <v-col cols="12" sm="6" lg="6">
              <base-material-stats-card color="info" icon="mdi-text" title="No Documento"
                :value="NumeroDocPopUp.toString()" />
            </v-col>

            <v-col cols="4" sm="4" lg="4">
              <base-material-stats-card color="primary" icon="mdi-credit-card-marker" title="Valor $"
                :value="formatNumber(ValorPopUp.toString())" />
            </v-col>
            <v-col cols="4" sm="4" lg="4">
              <base-material-stats-card color="success" icon="mdi-credit-card-refund" title="Pagos $"
                :value="sumValor" />
            </v-col>

            <v-col cols="4" sm="4" lg="4">
              <base-material-stats-card color="orange" icon="mdi-credit-card-marker" title="Saldo $"
                :value="CalculoSaldo" />
            </v-col>
          </v-row>
          <v-form ref="form2" v-model="validForm2">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">

                  <v-autocomplete v-model="metodo" :items="metodos" dense filled label="Metodo" required
                    :rules="requiredRule"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="payment_day" label="Fecha de pago" prepend-icon="mdi-calendar" readonly
                        v-bind="attrs" v-on="on" :rules="requiredRule"></v-text-field>
                    </template>
                    <v-date-picker v-model="payment_day" @input="menu2 = false"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="amount_paid" label="Monto" required :rules="requiredRule"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <v-text-field v-model="reference" label="Referencia"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-btn color="primary" @click="guardarPayments()"> Guardar </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>


          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-data-table :headers="paymentHeaders" :items="payments" sort-by="calories" class="elevation-1"
                :search="search" :loading="loadingTable" loading-text="Cargando... Por favor esperar">
                <template v-slot:item.payment_date="{ item }">
                  {{ formatDate(item.payment_date) }}
                </template>
                <template v-slot:item.amount_paid="{ item }">
                  {{ formatCurrency(item.amount_paid) }}
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="3"><strong>Total:</strong></td>
                    <td class="text-left"><strong>{{ formatCurrency(sumValor) }}</strong></td>

                    <td></td> <!-- Espacio para acciones -->
                  </tr>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" large @click="deletePayment(item)">
                        <v-icon dense color="primary">mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Eliminar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "DashboardExtendedTables",

  data: () => ({
    metodos: ['Transferencia', 'Efectivo', 'Cheque', 'Otros'],
    metodo: ['Efectivo'],
    selectedId: '',
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Proveedor", value: "name" },
      { text: "Numero", value: "invoice_number" },
      { text: "Concepto", value: "concept" },
      { text: "Monto", value: "amount" },
      { text: "Pagos", value: "total_paid_payable" },
      { text: "Saldo", value: "balance_due_payable" },
      { text: "Facha Pago", value: "due_date" },
      //{ text: "Fecha Creacion", value: "add_date" },
      //{ text: "usuario", value: "concept" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    payment: [],
    payments: [],
    paymentHeaders: [
      { text: "payment_method", value: "payment_method" },
      { text: "reference", value: "reference" },
      { text: "Fecha de Pago", value: "payment_date" },
      { text: "Monto", value: "amount_paid" },

      //{ text: "notes", value: "notes" },
      { text: "Acciones", value: "actions", sortable: false }],
    AccountsPayable: [],
    editedIndex: -1,
    AccountsPayables: [],
    search: "",
    loadingTable: false,
    snackbar: false,
    text: "",
    timeout: 6000,
    urbanizaciones: [],
    urbanizacion: [],
    edificios: [],
    edificio: [],
    proveedores: [],
    proveedor: [],
    //popup
    Propietario: "",
    Tipo: "",
    Tipos: ["Casa", "Apartamento", "Local", "Oficina"],
    No: "",
    Piso: "",
    Area: "",
    TipoDocuemnto: "",
    TipoDocuemntos: ["Cedula", "RUC", "Pasaporte", "Otro"],
    //crear nuevo 
    invoice_number: "",
    concept: "",
    amount: "",
    due_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    payment_day: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    notes: "",
    //pop up registro de pagos
    dialogDetails: false,
    descriptionPopUp: "",
    NumeroDocPopUp: "",
    saldoPopUp: 0,
    ValorPopUp: 0,
    PagosPopUp: 0,
    id: "",
    validForm: false,
    validForm2: false,
    requiredRule: [(v) => !!v || 'Este campo es obligatorio'],
    menu1: false,
    menu2: false,
    amount_paid: 0,

    reference: "",
    row: null,
    estado: "",


  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nueva cuenta" : "Editar cuenta";
    },

    sumValorRaw() {
      // Valor numérico real
      return this.payments.reduce((sum, item) => sum + (parseFloat(item.amount_paid) || 0), 0);
    },

    sumValor() {
      // Formato para mostrar
      return this.formatNumber(this.sumValorRaw);
    },

    CalculoSaldoRaw() {
      // Cálculo sin formato

      return (parseFloat(this.ValorPopUp) || 0) - this.sumValorRaw;
    },

    CalculoSaldo() {
      // Formato para mostrar
      return this.formatNumber(this.CalculoSaldoRaw);
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.listarUrbanizaciones();
    },
    getColor(balance_due) {
      if (balance_due > 0) return 'red lighten-3'
      else if (balance_due == 0) return 'light-green lighten-2'
      else return 'orange lighten-1'
    },
    changeRow(value) {
      let me = this;
      console.log("Valor seleccionado:", value);
      me.estado = value;
      me.listar();
    },
    listaProveedores(Building_uq) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.proveedores = [];
      axios
        .get("/api/Suplliers/SuppliersByBuilding/" + Building_uq, configuracion)
        .then(function (response) {
          me.proveedores = response.data;

          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarUrbanizaciones() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Communities", configuracion)
        .then(function (response) {
          me.urbanizaciones = response.data;
          me.Properties = []; //limpiar propiedades cuando selecciono otra urbanizacion
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarEdificios() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.edificios = [];
      axios
        .get("api/Buildings/BuildingByCommunity/" + me.urbanizacion.id, configuracion)
        .then(function (response) {
          me.edificios = response.data;
          me.Properties = []; //limpiar propiedades cuando selecciono otra urbanizacion
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    formatDate(date) {
      if (!date) return ""; // Evita errores si la fecha es nula o indefinida
      // Maneja valores nulos o indefinidos
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    },
    formatCurrency(value) {
      if (value == null) return "$0.00";
      return `$${parseFloat(value).toFixed(2)}`;
    },
    formatNumber(value) {
      return parseFloat(value).toFixed(2);
    },
    listar() {
      let me = this;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.loadingTable = true;
      me.AccountsPayables = [];
      axios
        .get("api/AccountsPayables/AccountsPayable/" + me.edificio.id + "/" + me.estado, configuracion)
        .then(function (response) {
          me.AccountsPayables = response.data;
          me.loadingTable = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },
    listarPayments() {
      let me = this;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      //me.loadingTable = true;
      me.payments = [];
      axios
        .get("/api/AccountsPayablesPayments/AccountsPayablePayments/" + me.id, configuracion)
        .then(function (response) {
          me.payments = response.data;
          //change to string bool value
          //me.loadingTable = false;
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      console.log("Entre antes de guardar");
      if (this.$refs.form.validate()) {
        if (me.editedIndex > -1) {
          //edit
          console.log("editar propiedad");
          axios
            .post(
              "/api/AccountsPayables/UpdateccountPayable",
              {
                id: me.id,
                supplier_uq: me.proveedor.id,
                invoice_number: me.invoice_number,
                concept: me.concept,
                amount: me.amount,
                due_date: me.due_date,
                payment_status: "Pendiente",
                notes: me.notes,
                user_id: localStorage.getItem("unico")
              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              me.$refs.form.reset();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        } else {
          console.log("crear propiedad");
          axios
            .post(
              "/api/AccountsPayables/InsertAccountPayable",
              {
                supplier_uq: me.proveedor.id,
                invoice_number: me.invoice_number,
                concept: me.concept,
                amount: me.amount,
                due_date: me.due_date,
                payment_status: "Pendiente",
                notes: me.notes,
                user_id: localStorage.getItem("nombre")

              },
              configuracion
            )
            .then(function (response) {
              me.listar();
              me.$refs.form.reset();
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 400) {
                me.snackbar = true;
                me.text = err.response.data.errors;
              }
              if (err.response.status == 401) {
                this.$store.dispatch("salir");
              }
            });
        }
        me.close();
      }


    },
    guardarPayments() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      console.log("Entre antes de guardar");

      if (this.$refs.form2.validate()) {
        axios
          .post(
            "api/AccountsPayablesPayments/InsertAccountPayablePayments",
            {
              account_payable_uq: me.id,
              payment_date: me.payment_day,
              amount_paid: me.amount_paid,
              payment_method: me.metodo,
              reference: me.reference,
              notes: "",
              user_id: localStorage.getItem("nombre")
            },
            configuracion
          )
          .then(function (response) {
            // me.listar();

            me.listarPayments();
            console.log(response);
            if (response.data[0]["error"]) {
              me.snackbar = true;
              me.text = response.data[0]["messagge"];
            } else {
              me.snackbar = true;
              me.text = "Pago registrado correctamente";
              me.Refrescar();
              me.$refs.form2.reset();


            }
          })
          .catch((err) => {
            if (err.response.status == 400) {
              me.snackbar = true;
              me.text = err.response.data.errors;
            }
            if (err.response.status == 401) {
              this.$store.dispatch("salir");
            }
          });
      }
    },
    Refrescar() {
      let me = this;
      me.amount_paid = 0;
      me.reference = "";
      me.payment_day = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    },
    deleteItem(item) {
      let me = this;
      me.selectedId = item.id;
      console.log(item);
      me.dialogDelete = true;
    },
    deleteItemConfirm() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("/api/AccountsPayables/Delete/" + me.selectedId, configuracion)
        .then(function (response) {
          me.dialogDelete = false;
          if (response.data[0]["error"]) {
            me.snackbar = true;
            me.text = response.data[0]["messagge"];
          }
          me.listar();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },
    deletePayment(item) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("/api/AccountsPayablesPayments/Delete/" + item.id, configuracion)
        .then(function (response) {
          me.dialogDelete = false;
          if (response.data[0]["error"]) {
            me.snackbar = true;
            me.text = response.data[0]["messagge"];
          } else {
            me.listarPayments();
          }

        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },

    editar(item) {
      let me = this;
      me.id = item.id;
      me.Propietario = item.owner;
      me.Tipo = item.propertyType;
      me.No = item.unitNumber;
      me.Piso = item.floor;
      me.Area = item.area;
      me.TipoDocuemnto = item.documentType;
      me.NoDocumento = item.documentNo;
      me.Email = item.email;
      me.Telefono = item.phone;

      me.editedIndex = 1;
      me.dialog = true;
    },
    close() {
      let me = this;
      me.dialog = false;

    },
    closeDelete() {
      this.dialogDelete = false;

    },
    openDetalle(item) {
      let me = this;
      me.dialogDetails = true;
      me.id = item.id;
      me.descriptionPopUp = item.name;
      me.NumeroDocPopUp = item.invoice_number;
      me.saldoPopUp = item.balance_due_payable;
      me.ValorPopUp = item.amount;
      me.PagosPopUp = item.total_paid_payable;
      me.listarPayments();
      me.amount_paid = me.saldoPopUp;
      console.log(item);
    },
  },
};
</script>